import { render, staticRenderFns } from "./history-item.vue?vue&type=template&id=84b9d050"
import script from "./history-item.vue?vue&type=script&lang=js"
export * from "./history-item.vue?vue&type=script&lang=js"
import style0 from "./history-item.vue?vue&type=style&index=0&id=84b9d050&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports